import LoginPage from './login-page/LoginPage';
import UserInfoPage from './user-info-page/UserInfoPage';
import UserCenter from './user-center/UserCenter';
import BindPhonePage from './bind-phone-page/BindPhonePage';
import Recharge from './recharge/Recharge';
import RechargeIntegral from './recharge-integral/RechargeIntegral';
import Balance from './balance/Balance';
import GoodsDetail from './goods-detail/GoodsDetail';
import ShoppingCart from './shopping-cart/ShoppingCart';
import MyOrder from './my-order/MyOrder';
import GoodsOrderDetail from './goods-order-detail/GoodsOrderDetail';
import MyAddress from './my-address/MyAddress';
import GoodsOrderProgress from './goods-order-progress/GoodsOrderProgress';
import LogisticsPage from './logistics-page/LogisticsPage';
import MakeComment from './make-comment/MakeComment';
import PreviewGoodsRefund from './preview-goods-refund/PreviewGoodsRefund';
import GoodsRefundPage from './goods-refund-page/GoodsRefundPage';
import PreviewGoodsOrder from './preview-goods-order/PreviewGoodsOrder';
import AddAddress from './add-address/AddAddress';
import GoodsOrderPaySuccess from './goods-order-pay-success/GoodsOrderPaySuccess';
import GoodsComment from './goods-comment/GoodsComment';
import GoodsAdditionalInfo from './goods-additional-info/GoodsAdditionalInfo';
import GoodsFavorites from './goods-favorites/GoodsFavorites';
import GoodsFootPrint from './goods-foot-print/GoodsFootPrint';
import GoodsCustomerService from './goods-customer-service/GoodsCustomerService';
import GoodsAfterSaleDetail from './goods-after-sale-detail/GoodsAfterSaleDetail';
import SearchAddress from './search-address/SearchAddress';
import CouponList from './coupon-list/CouponList';
import GoodsReturnInfor from './goods-return-infor/GoodsReturnInfor';
import GoodsDeliveryList from './goods-delivery-list/GoodsDeliveryList';
import GoodsAlreadyRefunded from './goods-already-refunded/GoodsAlreadyRefunded';
import SeckillDetail from './seckill-detail/SeckillDetail';
import CouponListPage from './coupon-list-page/CouponListPage';
import CouponGoodsListPage from './coupon-goods-list-page/CouponGoodsListPage';
import CouponReceiveListPage from './coupon-receive-list-page/CouponReceiveListPage';
import VipCard from './vip-card/VipCard';
import VipBenefits from './vip-benefits/VipBenefits';
import PreviewSeckillOrder from './preview-seckill-order/PreviewSeckillOrder';
import TransactionSuccess from './transaction-success/TransactionSuccess';
import SameJourneyLogistic from './same-journey-logistic/SameJourneyLogistic';
import ShareGifts from './share-gifts/ShareGifts';
import DiningOrderDetail from './dining-order-detail/DiningOrderDetail';
import RefundDishesDetail from './refund-dishes-detail/RefundDishesDetail';
import VerificationCodePage from './verification-code-page/VerificationCodePage';
import GoodsSameJourney from './goods-same-journey/GoodsSameJourney';
import MemberDay from './member-day/MemberDay';
import MemberDayDetail from './member-day-detail/MemberDayDetail';
import MemberDayList from './member-day-list/MemberDayList';
import TransferPage from './transfer-page/TransferPage';
import CouponDescription from './coupon-description/CouponDescription';
import MakeAppointment from './make-appointment/MakeAppointment';
import TransferOrderDetail from './transfer-order-detail/TransferOrderDetail';
import TransferPaySuccess from './transfer-pay-success/TransferPaySuccess';
import MyGroup from './my-group/MyGroup';
import PreviewAppointmentOrder from './preview-appointment-order/PreviewAppointmentOrder';
import AppointmentOrderDetail from './appointment-order-detail/AppointmentOrderDetail';
import WinningRecord from './winning-record/WinningRecord';
import MyMessage from './my-message/MyMessage';
import MyIntegral  from './my-integral/MyIntegral';
import GroupRules from './group-rules/GroupRules';
import GroupOrderDetail from './group-order-detail/GroupOrderDetail';
import GroupCenter from './group-center/GroupCenter';
import VipCardList from './vip-card-list/VipCardList';
import MyFormMessage from './my-form-message/MyFormMessage';
import OrderDetail from './order-detail/OrderDetail';
import ToStoreDetail from './to-store-detail/ToStoreDetail';
import CouponDetail from './coupon-detail/CouponDetail';
import BindCellphone from './bind-cellphone/BindCellphone';
import AdvanceSearch from './advance-search/AdvanceSearch';
import ExtensionPage from './extension-page/ExtensionPage';
import MapDetail from './map-detail/MapDetail';
import Paying from './paying/Paying';
import CollectStars from './collect-stars/CollectStars';
import LuckyWheelDetail from './lucky-wheel-detail/LuckyWheelDetail';
import GoldenEggs from './golden-eggs/GoldenEggs';
import Scratch from './scratch/Scratch';
import NumberOfStampsOrderDetail from './number-of-stamps-order-detail/NumberOfStampsOrderDetail';
import NumberOfStampsUsed from './number-of-stamps-used/NumberOfStampsUsed';
import ExchangeCouponDetail from './exchange-coupon-detail/ExchangeCouponDetail';
import ExchangeCouponDetailOrder from './exchange-coupon-detail-order/ExchangeCouponDetailOrder';
import CheckRowNumberDetail from './check-row-number-detail/CheckRowNumberDetail';
import PreviewRowNumberOrder from './preview-row-number-order/PreviewRowNumberOrder';
import RowNumberOrderDetail from './row-number-order-detail/RowNumberOrderDetail';
import GpGoodsDetail from './gp-goods-detail/GpGoodsDetail';
import GpPlayLaws from './gp-play-laws/GpPlayLaws';
import PreviewGroupOrder from './preview-group-order/PreviewGroupOrder';
import GpPaySuccess from './gp-pay-success/GpPaySuccess';
import GpMyOrder from './gp-my-order/GpMyOrder';
import GpOrderDetail from './gp-order-detail/GpOrderDetail';
import PreviewPresellOrder from './preview-presell-order/PreviewPresellOrder';
import PresellPaySuccess from './presell-pay-success/PresellPaySuccess';
import PresellOrderDetail from './presell-order-detail/PresellOrderDetail';
import PresellOrderList from './presell-order-list/PresellOrderList';
import PresellDetail from './presell-detail/PresellDetail';
import PreviewOrderDetail from './preview-order-detail/PreviewOrderDetail';
import PaySuccess from './pay-success/PaySuccess';
import ToStoreOrderDetail from './to-store-order-detail/ToStoreOrderDetail';
import ToStoreComment from './to-store-comment/ToStoreComment';
import MakeToStoreComment from './make-to-store-comment/MakeToStoreComment';
import PreviewTakeoutOrder from './preview-takeout-order/PreviewTakeoutOrder';
import TakeoutOrderDetail from './takeout-order-detail/TakeoutOrderDetail';
import OrderTracking from './order-tracking/OrderTracking';
import CancelOrder from './cancel-order/CancelOrder';
import TakeoutMakeComment from './takeout-make-comment/TakeoutMakeComment';
import TakeoutFeedback from './takeout-feedback/TakeoutFeedback';
import IndemnityOrder from './indemnity-order/IndemnityOrder';
import CommunityPage from './community-page/CommunityPage';
import CommunityDetail from './community-detail/CommunityDetail';
import VideoActivityDetail from './video-activity-detail/videoActivityDetail';
import videoActivityReward from './video-activity-reward/videoActivityReward';

import GptIndex from '../chatgpt-page/index/Index';
import Entrance from '../chatgpt-page/entrance/Entrance';
import PcRegister from '../chatgpt-page/pc-register/PcRegister';
import PcLogin from '../chatgpt-page/pc-login/PcLogin';
import PcIndex from '../chatgpt-page/pc-index/PcIndex';
import AddphonePage from '../chatgpt-page/addphone-page/AddphonePage';
import SignIn from '../chatgpt-page/sign-in/SignIn';
import RechargeGpt from '../chatgpt-page/recharge/Recharge';
import AudioTest from '../chatgpt-page/audio-test/AudioTest';
import SharePage from '../chatgpt-page/share-page/SharePage.jsx';
import TapPay from './tap-pay/TapPay'

const officialPageList = {
  // 登录页面
  'loginPage': (props) => <LoginPage {...props}/>,
  // 用户信息页面（旧版web）
  'userInfoPage': (props) => <UserInfoPage {...props}/>,
  // 用户信息页面（同步新版）
  'userCenter': (props) => <UserCenter {...props}/>,
  // 绑定手机页面（旧版web）
  'bindPhonePage': (props) => <BindPhonePage {...props}/>,
  // 储值：充值页面
  'recharge': (props) => <Recharge {...props} />,
  // 积分：充值页面
  'rechargeIntegral': (props) => <RechargeIntegral {...props} />,
  // 储值：充值页面
  'balance': (props) => <Balance {...props} />,
  // 商品详情页面
  'goodsDetail': (props) => <GoodsDetail {...props} />,
  // 底部导航购物车
  'shoppingCart': (props) => <ShoppingCart {...props} />,
  // 购物车
  'goodsShoppingCart': (props) => <ShoppingCart {...props} />,
  // 我的订单页面
  'myOrder': (props) => <MyOrder {...props} />,
  // 我的地址
  'myAddress': (props) => <MyAddress {...props} />,
  // 订单详情页面
  'goodsOrderDetail': (props) => <GoodsOrderDetail {...props} />,
  // 订单进度页面
  'goodsOrderProgress': (props) => <GoodsOrderProgress {...props} />,
  // 物流信息页面
  'logisticsPage': (props) => <LogisticsPage {...props} />,
  // 评价页面
  'makeComment': (props) => <MakeComment {...props} />,
  // 申请退款页面
  'previewGoodsRefund': (props) => <PreviewGoodsRefund {...props} />,
  // 退款页面
  'goodsRefundPage': (props) => <GoodsRefundPage {...props} />,
  // 确认支付页面
  'previewGoodsOrder': (props) => <PreviewGoodsOrder {...props} />,
  // 添加、编辑地址
  'addAddress': (props) => <AddAddress {...props} />,
  // 支付成功页面
  'goodsOrderPaySuccess': (props) => <GoodsOrderPaySuccess {...props} />,
  // 商品评价页面
  'goodsComment': (props) => <GoodsComment {...props} />,
  // 商品补充信息页面
  'goodsAdditionalInfo': (props) => <GoodsAdditionalInfo {...props} />,
  // 收藏夹页面
  'goodsFavorites': (props) => <GoodsFavorites {...props} />,
  // 足迹页面
  'goodsFootPrint': (props) => <GoodsFootPrint {...props} />,
  // 售后订单页面
  'goodsCustomerService': (props) => <GoodsCustomerService {...props} />,
  // 售后订单详情页面
  'goodsAfterSaleDetail': (props) => <GoodsAfterSaleDetail {...props} />,
  // 地址搜索页面
  'searchAddress': (props) => <SearchAddress {...props} />,
  // 优惠券列表
  'couponList': (props) => <CouponList {...props} />,
  // 填写退货信息页面
  'goodsReturnInfor': (props) => <GoodsReturnInfor {...props} />,
  // 选择自提点页面
  'goodsDeliveryList': (props) => <GoodsDeliveryList {...props} />,
  // 已退商品页面
  'goodsAlreadyRefunded': (props) => <GoodsAlreadyRefunded {...props} />,
  // 秒杀详情页面
  'seckillDetail': (props) => <SeckillDetail {...props} />,
  // 多商家优惠券列表
  'couponListPage': (props) => <CouponListPage {...props} />,
  // 优惠券可用商品列表
  'couponGoodsListPage': (props) => <CouponGoodsListPage {...props} />,
  // 优惠券领取列表
  'couponReceiveListPage': (props) => <CouponReceiveListPage {...props} />,
  // 会员卡
  'vipCard': (props) => <VipCard {...props} />,
  // 会员权益
  'vipBenefits': (props) => <VipBenefits {...props} />,
  // 确认支付(秒杀)页面
  'previewSeckillOrder': (props) => <PreviewSeckillOrder {...props} />,
  // 评价成功页面
  'transactionSuccess': (props) => <TransactionSuccess {...props} />,
  // 同城配送信息页面
  'sameJourneyLogistic': (props) => <SameJourneyLogistic {...props} />,
  // 分享有礼页面
  'shareGifts': (props) => <ShareGifts {...props} />,
  // 堂食订单详情页面
  'diningOrderDetail': (props) => <DiningOrderDetail {...props} />,
  // 堂食订单退款详情页面
  'refundDishesDetail': (props) => <RefundDishesDetail {...props} />,
  // 核销码页面
  'verificationCodePage': (props) => <VerificationCodePage {...props} />,
  // 同城配送点选择页面
  'goodsSameJourney': (props) => <GoodsSameJourney {...props} />,
  // 会员日
  'memberDay': (props) => <MemberDay {...props} />,
  // 会员日详情
  'memberDayDetail': (props) => <MemberDayDetail {...props} />,
  // 会员日列表
  'memberDayList': (props) => <MemberDayList {...props} />,
  // 当面付
  'transferPage': (props) => <TransferPage {...props} />,
  // 优惠说明页面
  'couponDescription': (props) => <CouponDescription {...props} />,
  // 预约页面
  'makeAppointment': (props) => <MakeAppointment {...props} />,
  // 当面付订单详情页
  'transferOrderDetail': (props) => <TransferOrderDetail {...props} />,
  // 当面付支付成功页
  'transferPaySuccess': (props) => <TransferPaySuccess {...props} />,
  // 我的拼团(旧版路由跳到新版)
  // 'myGroup': (props) => <MyGroup {...props} />,
  'myGroup': (props) => <GpMyOrder {...props} />,
  // 预约订单确认支付页面
  'previewAppointmentOrder': (props) => <PreviewAppointmentOrder {...props} />,
  // 预约订单详情页
  'appointmentOrderDetail': (props) => <AppointmentOrderDetail {...props} />,
  // 中奖记录页面
  'winningRecord': (props) => <WinningRecord {...props} />,
  // 系统通知页面
  'myMessage': (props) => <MyMessage {...props} />,
  // 个人积分页面
  'myIntegral': (props) => <MyIntegral {...props} />,
  // 拼团规则
  'groupRules': (props) => <GroupRules {...props} />,
  // 拼团订单详情
  'groupOrderDetail': (props) => <GroupOrderDetail {...props} />,
  // 拼团中心
  'groupCenter': (props) => <GroupCenter {...props} />,
  // 会员卡列表
  'vipCardList': (props) => <VipCardList {...props} />,
  // 表单提交信息
  'myFormMessage': (props) => <MyFormMessage {...props} />,
  // 订单详情页
  'orderDetail': (props) => <OrderDetail {...props} />,
  // 到店详情
  'toStoreDetail': (props) => <ToStoreDetail {...props} />,
  // 优惠券详情
  'couponDetail': (props) => <CouponDetail {...props} />,
  // 绑定手机号码
  'bindCellphone': (props) => <BindCellphone {...props} />,
  // 商品搜索页
  'advanceSearch': (props) => <AdvanceSearch {...props} />,
  // 推广页
  'extensionPage': (props) => <ExtensionPage {...props} />,
  // 地图详情页
  'mapDetail': (props) => <MapDetail {...props} />,
  // 支付中间跳转页（微信h5支付，支付宝h5支付，支付宝pc支付）
  'paying': (props) => <Paying {...props} />,
  // 集集乐
  'collectStars': (props) => <CollectStars {...props} />,
  // 大转盘
  'luckyWheelDetail': (props) => <LuckyWheelDetail {...props} />,
  // 砸金蛋
  'goldenEggs': (props) => <GoldenEggs {...props} />,
  // 刮刮乐
  'scratch': (props) => <Scratch {...props} />,
  // 兑换券订单详情
  'numberOfStampsOrderDetail': (props) => <NumberOfStampsOrderDetail {...props} />,
  // 兑换券核销码
  'numberOfStampsUsed': (props) => <NumberOfStampsUsed {...props} />,
  // 兑换券详情
  'exchangeCouponDetail': (props) => <ExchangeCouponDetail {...props} />,
  // 确认订单
  'exchangeCouponDetailOrder': (props) => <ExchangeCouponDetailOrder {...props} />,
  // 保存号单
  'checkRowNumberDetail': (props) => <CheckRowNumberDetail {...props} />,
  // 确认支付
  'previewRowNumberOrder': (props) => <PreviewRowNumberOrder {...props} />,
  // 订单详情
  'rowNumberOrderDetail': (props) => <RowNumberOrderDetail {...props} />,
  // 拼团商品详情
  'gpgoodsDetail': (props) => <GpGoodsDetail {...props} />,
  // 拼团须知
  'gpplaylaws': (props) => <GpPlayLaws {...props} />,
  // 拼团确认订单
  'previewGroupOrder': (props) => <PreviewGroupOrder {...props} />,
  // 拼团支付成功
  'gppaySuccess': (props) => <GpPaySuccess {...props} />,
  // 我的拼团
  'gpmyOrder': (props) => <GpMyOrder {...props} />,
  // 拼团订单详情
  'gporderDetail': (props) => <GpOrderDetail {...props} />,
  // 预售确认订单
  'previewPresellOrder': (props) => <PreviewPresellOrder {...props} />,
  // 预售支付成功
  'presellPaySuccess': (props) => <PresellPaySuccess {...props} />,
  // 预售订单详情
  'presellOrderDetail': (props) => <PresellOrderDetail {...props} />,
  // 预售订单列表
  'presellOrderList': (props) => <PresellOrderList {...props} />,
  // 预售商品详情
  'presellDetail': (props) => <PresellDetail {...props} />,
  // 到店确认支付
  'previewOrderDetail': (props) => <PreviewOrderDetail {...props} />,
  // 到店支付成功
  'paySuccess': (props) => <PaySuccess {...props} />,
  // 到店订单详情
  'tostoreOrderDetail': (props) => <ToStoreOrderDetail {...props} />,
  // 到店商品评价
  'tostoreComment': (props) => <ToStoreComment {...props} />,
  // 到店评价
  'makeTostoreComment': (props) => <MakeToStoreComment {...props} />,
  // 外卖确认支付
  'previewTakeoutOrder': (props) => <PreviewTakeoutOrder {...props} />,
  // 外卖订单详情
  'takeoutOrderDetail': (props) => <TakeoutOrderDetail {...props} />,
  // 外卖订单跟踪
  'orderTracking': (props) => <OrderTracking {...props} />,
  // 外卖取消订单
  'cancelOrder': (props) => <CancelOrder {...props} />,
  // 外卖评价
  'takeoutMakeComment': (props) => <TakeoutMakeComment {...props} />,
  // 外卖问题反馈
  'takeoutFeedback': (props) => <TakeoutFeedback {...props} />,
  // 外卖反馈详情
  'indemnityOrder': (props) => <IndemnityOrder {...props} />,
  // 圈组详情
  'communityPage': (props) => <CommunityPage {...props} />,
  // 话题详情
  'communityDetail': (props) => <CommunityDetail {...props} />,
  // 发视频有礼活动详情
  'videoActivityDetail': (props) => <VideoActivityDetail {...props} />,
  // 发视频有礼活动领取奖励详情
  'videoActivityReward': (props) => <videoActivityReward {...props} />,
  // gpt问答页
  'gptIndex': (props) => <GptIndex {...props} />,
  // gpt入口页
  'jisugpt': (props) => <Entrance {...props} />,
  'register-pc': (props) => <PcRegister {...props} />,
  'login-pc': (props) => <PcLogin {...props} />,
  'jisuSession': (props) => <PcIndex {...props} />,
  'add-phone': (props) => <AddphonePage {...props} />,
  'signin': (props) => <SignIn {...props} />,
  'gptrecharge': (props) => <RechargeGpt {...props} />,
  // 语音转文字测试页
  'audio-test': (props) => <AudioTest {...props} />,
  'share-page': (props) => <SharePage {...props} />,
  // 投流h5点击支付页
  'tap-pay': (props)=> <TapPay {...props}/>,

  
}
export default officialPageList;
 


// WEBPACK FOOTER //
// ./src/official-page/officialPageList.jsx